module.exports = __webpack_public_path__ + "d6fc69486c67ef31bbd771f285af8d78.MP3";